export enum AnsweredQuestionResult {
  RIGHT = 'RIGHT',
  WRONG = 'WRONG',
  FREE = 'FREE',
}
